module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header-modal', {
    staticClass: "fade",
    attrs: {
      "id": "error-modal",
      "headerStyle": "alert alert-danger",
      "headerRole": "alert"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalLabel"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" エラー\n  ")]), _vm._v(" "), _vm._t("default", [_vm._v("エラーが発生しました。")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    slot: "footer"
  }, [_vm._v("OK")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b0057ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorModal.vue
// module id = 89
// module chunks = 1 2